import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'shareSegmentListFilter',
  pure: false
})
export class ShareSegmentListPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    filter = filter.toLowerCase();
    if (!items || !filter) {
      return items;
    }
    return items.filter((item) => {
      if (item.accounts !== undefined) {
        const accounts = item.accounts.filter((account: any) => this.searchForString(account.description, filter));
        return (this.searchForString(item.targetName, filter) || accounts.length > 0);
      } else {
        return this.searchForString(item.description, filter);
      }
    });
  }

  searchForString(account: any, filter: string) {
    // the string 'emetriq' is removed because it is present in most if not all account descriptions
    // and clutters the results when searching for short strings i.e. 'iq' when searching for iqd (IQ Digital)
    return account.replace(/emetriq/, '').toLowerCase().includes(filter);
  }
}
